import React from "react";
import { useLivraisonSuivi } from "../hooks/useLivraisonSuivi";
import { formatDeliveryDateHeader, formatTime } from "../model/suiviLivraisonFormat";
import { caissesLabel, isNearScrollEnd, photosLabel } from "../model/suiviLivraisonRules";
import { deliveryDateGroupStyle, deliveryDateHeaderStyle, listMoreStyle, livraisonListItemStyle } from "../styles/suiviLivraisonStyles";
import { LivraisonDetail } from "./LivraisonDetail";
import { EmptyState } from "./SuiviBadges";

// Suivi livraison : livraisons effectuées groupées par jour à gauche, détail de la livraison sélectionnée à droite.

const SCROLL_THRESHOLD = 100;

export function LivraisonSuivi({ ehpadId, dateLivraison, refreshSignal, onViewPhoto }) {
    const suivi = useLivraisonSuivi({ ehpadId, dateLivraison, refreshSignal });

    function handleScroll(event) {
        if (isNearScrollEnd(event.currentTarget, SCROLL_THRESHOLD)) suivi.loadMore();
    }

    return (
        <div style={{ flex: 1, minHeight: 0, display: "grid", gridTemplateColumns: "360px minmax(0, 1fr)", background: "#f8fafc" }}>
            <div onScroll={handleScroll} style={{ minHeight: 0, overflow: "auto", borderRight: "1px solid #e2e8f0", background: "white", padding: "14px" }}>
                <LivraisonList suivi={suivi} />
            </div>
            <div style={{ minHeight: 0, overflow: "auto", padding: "14px 16px" }}>
                <LivraisonDetailPane suivi={suivi} onViewPhoto={onViewPhoto} />
            </div>
        </div>
    );
}

function LivraisonList({ suivi }) {
    const { loading, livraisons, totalElements, byDate, selected, loadingMore, hasMore, select } = suivi;
    if (loading) return <EmptyState>Chargement…</EmptyState>;
    if (livraisons.length === 0) return <EmptyState>Aucune livraison trouvée.</EmptyState>;
    return (
        <>
            <div style={{ color: "#64748b", fontSize: "12px", marginBottom: "10px" }}>
                {totalElements} livraison{totalElements > 1 ? "s" : ""} effectuée{totalElements > 1 ? "s" : ""}
            </div>
            {byDate.map(group => (
                <section key={group.key} style={deliveryDateGroupStyle}>
                    <div style={deliveryDateHeaderStyle}>
                        <span>{formatDeliveryDateHeader(group.date)}</span>
                        <span>{group.items.length} livraison{group.items.length > 1 ? "s" : ""}</span>
                    </div>
                    {group.items.map(livraison => (
                        <LivraisonListItem
                            key={livraison.id}
                            livraison={livraison}
                            active={selected?.id === livraison.id}
                            onClick={() => select(livraison)}
                        />
                    ))}
                </section>
            ))}
            {loadingMore && <div style={listMoreStyle}>Chargement des livraisons suivantes…</div>}
            {!loadingMore && hasMore && <div style={listMoreStyle}>Faites défiler pour charger les livraisons suivantes.</div>}
        </>
    );
}

function LivraisonDetailPane({ suivi, onViewPhoto }) {
    if (!suivi.selected) return <EmptyState>Sélectionnez une livraison pour voir son détail.</EmptyState>;
    if (suivi.detailLoading) return <EmptyState>Chargement du détail…</EmptyState>;
    return <LivraisonDetail livraison={suivi.detail || suivi.selected} onViewPhoto={onViewPhoto} />;
}

function LivraisonListItem({ livraison, active, onClick }) {
    return (
        <button type="button" onClick={onClick} style={livraisonListItemStyle(active)}>
            <span style={{ minWidth: 0 }}>
                <span style={{ display: "block", color: "#0f172a", fontWeight: 800, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {livraison.ehpadNom || livraison.ehpadCode || "EHPAD non renseigné"}
                </span>
                <span style={{ display: "block", color: "#64748b", fontSize: "12px", marginTop: "3px" }}>
                    {[formatTime(livraison.dateLivraison), livraison.tourneeName].filter(Boolean).join(" · ")}
                </span>
                <span style={{ display: "block", color: "#94a3b8", fontSize: "11px", marginTop: "5px" }}>
                    {caissesLabel(livraison)}
                    {photosLabel(livraison)}
                </span>
            </span>
            <span style={{ color: active ? "#2563eb" : "#cbd5e1", fontSize: "22px", lineHeight: 1 }}>›</span>
        </button>
    );
}
